import facebookIcon from '@/assets/icons/facebook.png'
import instagramIcon from '@/assets/icons/instagram.png'
import tiktokIcon from '@/assets/icons/tik-tok.png'
import youtubeIcon from '@/assets/icons/youtube.png'
import landingBg from '@/assets/images/home/landing-background.jpg'
import profile from '@/assets/images/home/landing-profile.jpg'
import {
  pageMaxWidth,
  pageXPadding,
  pageYPadding,
  socialHandles,
} from '@/config'
import { Button } from '../Button'
import { CompnayDetail, useCompanyDetail } from '@/features/public/contact'

export const Landing = () => {
  const companyDetail = useCompanyDetail()
  if (companyDetail.isLoading) {
    return (
      <div className="flex h-96 w-full items-center justify-center">
        <div className="size-[1em] animate-loader  rounded-[50%] text-[45px] text-[#D4AF37]"></div>
      </div>
    )
  }
  socialHandles.forEach((handle) => {
    if (companyDetail.data) {
      handle.url =
        companyDetail.data[`${handle.title}Link` as keyof CompnayDetail] ||
        handle.url
    }
  })

  return (
    <>
      <section className={`${pageXPadding} ${pageYPadding}`}>
        <div className={`${pageMaxWidth} mx-auto`}>
          <div className="flex w-full max-w-[581px] flex-col gap-y-[12px]">
            <h2 className="font-nunito text-[24px] font-bold  leading-[28.8px] text-[#333333] md:text-[28px] md:leading-[30.4px] lg:text-[32px]  lg:leading-[38.4px] ">
              Transforming Spaces with
            </h2>
            <h2 className="font-nunito text-[40px] leading-[48px] text-[#D4AF37] [font-weight:800] md:text-[52px] md:leading-[62.4px] lg:text-[64px] lg:font-[800] lg:leading-[76.8px]">
              Timeless Elegance
            </h2>
            <p className="font-nunito text-sm font-normal leading-[22.4px] text-[#333333] md:text-[19px] md:leading-[30.4px] lg:text-[24px] lg:font-[400] lg:leading-[38.4px] ">
              We listen to your needs and work closely with you to design spaces
              that meet your expectations. Your satisfaction is our priority.
            </p>
            <Button>Our Projects</Button>
          </div>
        </div>
      </section>
      <section
        className={`relative  mt-[52vw]  flex h-screen max-h-[249px] min-h-[249px]  w-full items-center justify-center bg-contain md:max-h-[381.5px] lg:mt-0 lg:max-h-[514px] lg:justify-start  ${pageXPadding} ${pageYPadding}`}
      >
        <div className="absolute bottom-[218px] left-1/2 h-[57.9vw] max-h-[521px]  min-h-[242px] w-[48.8vw] min-w-[198px] max-w-[439.09px] translate-x-[-34.2%]  border-4 border-[#D4AF37] md:bottom-[350.5px] lg:bottom-[348px] lg:left-full lg:translate-x-[-110%] lg:border-8"></div>
        <div className="absolute bottom-[107px]  left-1/2 z-30   -translate-x-1/2  md:bottom-[181px] lg:bottom-[176px] lg:left-full lg:translate-x-[-125%]">
          <img
            src={profile}
            className="mb-[10px] h-[57.9vw] max-h-[521px] min-h-[249px] w-[48.8vw] min-w-[210px]  max-w-[439.09px] border-2 border-[#D4AF37] object-cover md:mb-[20px] "
          />
          <div className="flex flex-col items-end justify-center gap-x-[12px] ">
            <span className="font-nunito text-[24px]  font-bold leading-[38.4px] text-[#FFFFFF] md:text-[28px] lg:text-[32px]">
              Bishal Gurung
            </span>
            <div className="flex items-center gap-x-[8px]">
              {socialHandles.map(({ title, url }, index) => (
                <a
                  href={url}
                  key={index}
                  className="cursor-pointer"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={
                      title === 'facebook'
                        ? facebookIcon
                        : title === 'youtube'
                          ? youtubeIcon
                          : title === 'tiktok'
                            ? tiktokIcon
                            : instagramIcon
                    }
                    className="size-[25px] md:size-[34px]"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="absolute inset-0 z-10 bg-[rgba(0,0,0,0.5)]"></div>
        <img
          className="absolute inset-0 z-0 size-full object-cover"
          src={landingBg}
        />
        <div className={`mx-auto  ${pageMaxWidth}`}>
          <p className="relative z-20 mt-32 max-w-[655px] text-center font-nunito text-[14px] font-bold leading-[22.4px] text-[#FFFFFF] md:mt-40  md:text-[25px] md:leading-[40px] lg:mt-0 lg:w-1/2 lg:max-w-full lg:text-left lg:text-[36px] lg:font-bold lg:leading-[57.6px]">
            {`Interior design is not just about making spaces look beautiful; it's
          about creating environments that enhance the way you live, work, and
          feel.`}
          </p>
        </div>
      </section>
    </>
  )
}
